import { render, staticRenderFns } from "./FilesCrud.vue?vue&type=template&id=a532d032&scoped=true"
import script from "./FilesCrud.vue?vue&type=script&lang=js"
export * from "./FilesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a532d032",
  null
  
)

export default component.exports